export default __webpack_public_path__ + "new_day_carousel.png";